import React from 'react';
import ColumnaBotoneraItem from '../ColumnaBotoneraItem.js';
import styles from '../CuadroListaEditable.module.css';
import styleCols from './TablaTorneoSedes.module.css';

const TablaTorneoSedes = (props) => {
  const lista = props.lista;
  const idElegido = props.idElegido;
  const onEditarItem = props.onEditarItem;
  const onEliminarItem = props.onEliminarItem;

  const esIdElegido = (idItem) => {
    return Number(idElegido) === Number(idItem);
  };

  return (
    <React.Fragment>
      <tr className={`${styles.titulos}`} key="0">
        <td className={`${styleCols.pais}`}>País Sede</td>
        <td className={`${styles.editar}`}></td>
      </tr>
      {lista &&
        lista.map((item) => (
          <tr
            className={`${styles.valores} ${esIdElegido(item.id) && styles.elegido}`}
            key={item.id}
          >
            <td className={`${styleCols.pais}`}>{item.paisSede?.nombre || ''}</td>
            <ColumnaBotoneraItem
              idItem={item.id}
              onEditarItem={onEditarItem}
              onEliminarItem={onEliminarItem}
            />
          </tr>
        ))}
    </React.Fragment>
  );
};

export default TablaTorneoSedes;
